import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const SharedReviewSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-lg)',
      padding: 'clamp(1.5rem, 4vw, 3rem) var(--space-xl) clamp(2rem, 5vw, 3rem)',
      alignItems: 'center',
      maxWidth: '720px',
      margin: '0 auto',
    }}
  >
    {/* Header */}
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
      <SkeletonCircle size={32} />
      <SkeletonText widths={['min(280px, 70vw)']} lineHeight="22px" />
    </div>

    {/* Progress bar */}
    <div style={{ width: '100%', maxWidth: '640px', display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
      <SkeletonBox height={8} borderRadius="999px" />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <SkeletonText widths={['56px']} lineHeight="12px" />
        <SkeletonText widths={['56px']} lineHeight="12px" />
      </div>
    </div>

    {/* Card */}
    <div
      style={{
        width: 'min(640px, 90vw)',
        aspectRatio: '3 / 2',
        background: 'var(--color-surface)',
        border: '1px solid var(--color-border-subtle)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-md)',
        padding: 'var(--space-xl)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 'var(--space-md)',
      }}
    >
      <SkeletonText widths={['80%']} lineHeight="28px" />
      <SkeletonText widths={['64%']} lineHeight="20px" />
      <SkeletonText widths={['40%']} lineHeight="16px" />
    </div>

    {/* Rating buttons */}
    <div style={{ display: 'flex', gap: 'var(--space-md)', flexWrap: 'wrap', justifyContent: 'center' }}>
      <SkeletonBox width={120} height={48} borderRadius="999px" />
      <SkeletonBox width={120} height={48} borderRadius="999px" />
      <SkeletonBox width={120} height={48} borderRadius="999px" />
      <SkeletonBox width={120} height={48} borderRadius="999px" />
    </div>
  </div>
);

export default SharedReviewSkeleton;
